import { BreakpointsMinQuery } from '@ab-core/breakpoints';
import { Colors } from '@ab-core/colors';
import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const NavigationElementWrapper = styled.div`
    &.ab-shop-navigation {
        padding: ${SPACING.SMALL_3};
        display: flex;
        gap: ${SPACING.MEDIUM_2};
        height: 48px;
        cursor: pointer;
        align-items: center;
        border-left: 4px solid ${Colors.white};
        @media ${BreakpointsMinQuery.md} {
            padding: ${SPACING.SMALL_3} ${SPACING.MEDIUM_2};
        }
        &.ab-shop-navigation:hover {
            background-color: ${Colors.backgroundShade};
            border-color: ${Colors.backgroundShade};
        }
        &.ab-shop-navigation-isActive {
            background-color: ${Colors.backgroundShade};
            border-color: ${Colors.primary};
        }
        &.ab-shop-navigation-isActivePremium {
            background-color: ${Colors.backgroundShade};
            border-color: ${Colors.gold};
        }
    }
`;
